<template>
  <div>
    <div class="layout mb-3">
      <v-select
        :items="itemsForSms"
        :value="itemSelected"
        @change="editSmsDialog"
        item-text="name"
        return-object
        class="v-select--3 v-text-field--noBorder mb-0 v-select--pointer"
        style="max-width: 150px"
        :menu-props="{ bottom: true, offsetY: true }"
        hide-details
        height="32"
        dense
        solo
      >
        <template #append>
          <hint-widget hintName="smsMailing" type="popover">
            <template slot="activatorHint">
              <span class="white--text">Отправить СМС</span>
              <icon-angle color="#ffffff" class="ml-2"></icon-angle>
            </template>
          </hint-widget>
        </template>
        <template v-slot:selection="{ item }">
          <div class="ellipsis">{{ item.name }}</div>
        </template>
        <template v-slot:item="{ item }">
          <div class="ellipsis">
            {{ item.name }}
          </div>
        </template>
      </v-select>
      <download-xlsx-csv
        :param="download ? download : {}"
        :type="type"
        class="flex text-sm-right flex-column align-self-center"
      >
      </download-xlsx-csv>
    </div>
    <div class="d-flex content-bg--4 pa-4" v-if="false">
      <div class="mx-3 mt-2 mb-3">
        <div class="subtitle-1 pb-2 font-weight-medium">340 СМС</div>
        <div class="subtitle-2 text--secondary">
          отправленно в рамках тарифа
        </div>
      </div>
      <div class="mr-3 mt-2 mb-3">
        <div class="subtitle-1 pb-2 font-weight-medium">5 СМС</div>
        <div class="subtitle-2 text--secondary">
          отправленно сверх тарифа
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HintWidget from "../common/HintWidget.vue";
import IconAngle from "../icon/IconAngle.vue";
import DownloadXlsxCsv from "../common/DownloadXlsxCsv.vue";
import Common from "../../modules/common";

export default {
  name: "SmsMailing",

  components: {
    IconAngle,
    DownloadXlsxCsv,
    HintWidget
  },
  data: () => ({
    itemSelected: {}
  }),
  computed: {
    // количество выбранных номеров телефонов
    countSelected() {
      return this.phoneSelected.size;
    },
    // для селекта с выбором скольким клиентам отправить смс
    itemsForSms() {
      return this.items();
    }
  },
  props: {
    //  параметры для скачивания файла
    download: {
      type: Object,
      required: true
    },
    // тип выгрузки
    type: {
      type: String,
      required: true
    },
    // количество всех уникальных пользователей для отправки смс
    countAllPhones: {
      type: Number,
      required: true
    },
    // массив с выбранными номерами
    phoneSelected: {
      type: Set,
      required: true
    }
  },

  methods: {
    /**
     * Открываем окно для подтверждения отправки смс
     */
    editSmsDialog(item) {
      let param = { data: item, hotspot_id: this.download.hotspot_id };
      if (!item.phones) {
        param.params = this.download;
        param.type = this.type;
      }
      this.$emit("editSmsDialog", param);
      this.itemSelected = {};
    },
    /**
     * Возвращает позиции выбора для селекта
     */
    items() {
      return [
        {
          name: `
              ${this.word(this.countAllPhones, "все", ["го", "м", "м"])} 
              ${this.countAllPhones} 
              ${this.word(this.countAllPhones, "номер", ["у", "ам", "ам"])}
            `,
          count: this.countAllPhones
          // phones: this.phoneAll,
        },
        {
          name: `
            ${this.word(this.countSelected, "выбранн", ["ому", "ым", "ым"])} 
            ${this.countSelected} 
            ${this.word(this.countSelected, "номер", ["у", "ам", "ам"])}`,
          count: this.countSelected,
          phones: this.phoneSelected,
          send: ""
        }
      ];
    },
    /**
     * Для получения слова с нужным окончанием в завасисмости от числа
     */
    word(count, wordWithoutEnd, endingArray) {
      return `${wordWithoutEnd}${Common.endingWord(count, endingArray)}`;
    }
  }
};
</script>
